import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Text from '../Text';

export const AutoSave = ({ autoSaved }) => {
  const { t } = useTranslation('tileForm');

  return (
    <Wrapper>
      {autoSaved.status === 'saving' && (
        <AutoSaveText>
          <i className="fa-regular fa-arrows-rotate" />
          {t('autosave.saving')}
        </AutoSaveText>
      )}
      {autoSaved.status === 'saved' && (
        <AutoSaveText
          data-tip={t('autosave.tooltip', { time: autoSaved.time })}
        >
          <i className="fa-regular fa-check" />
          {t('autosave.saved')}
        </AutoSaveText>
      )}
    </Wrapper>
  );
};

AutoSave.propTypes = {
  autoSaved: PropTypes.shape({
    status: PropTypes.string,
    time: PropTypes.string,
  }),
};

const Wrapper = styled.div`
  justify-self: start;
  grid-area: auto-save;
  margin-left: 12px;
`;

const AutoSaveText = styled(Text).attrs({ variant: 'small2' })`
  display: flex;
  gap: 6px;
  align-items: center;
`;
